import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const breadcrumbMap = {
    '/': { name: '首頁', path: '/' },
    '/about': { name: '關於我們', path: '/about' },
    '/services': { name: '設計服務', path: '/services' },
    '/process': { name: '設計流程', path: '/process' },
    '/projects': { name: '設計作品', path: '/projects' },
    '/contact': { name: '聯絡我們', path: '/contact' }
  };

  // 如果是首頁，不顯示麵包屑
  if (pathname === '/') {
    return null;
  }

  const currentPage = breadcrumbMap[pathname];
  
  if (!currentPage) {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="麵包屑導航">
      <div className="breadcrumb-container">
        <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
          <li className="breadcrumb-item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <Link 
              to="/" 
              className="breadcrumb-link"
              itemProp="item"
            >
              <span itemProp="name">首頁</span>
            </Link>
            <meta itemProp="position" content="1" />
            <span className="breadcrumb-separator" aria-hidden="true">›</span>
          </li>
          <li className="breadcrumb-item breadcrumb-current" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <span itemProp="name">{currentPage.name}</span>
            <meta itemProp="position" content="2" />
          </li>
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb; 